<template>
    <ul class="nav_breadcrumbs">
        <li>
            <router-link to="/modules/home">{{lang.LBL_HOME}}</router-link>
        </li>
        <li>
            <router-link to="/modules/studybudgets/edit">{{lang.LBL_ADD_BUDGETS}}</router-link>
        </li>
        <li>
            <router-link to="/modules/studybudgets">{{lang.LBL_VIEW_BUDGETS}}</router-link>
        </li>
    </ul>
</template>
<script>
    import lang from "@/views/modules/StudyBudgets/language/en";
    export default {
        name: "breadcrumbs",
        data() {
            return {
                lang: [],
            }
        },
        mounted() {
            this.lang = lang;
        },

    }
</script>